/* eslint-disable sort-keys */
import { Appstore, AppstoreFilled, AppstoreHover } from '@im/ui-lib/icons/nav/Appstore';
import { Bundles, BundlesFilled, BundlesHover } from '@im/ui-lib/icons/nav/Bundles';
import { BusinessPlanning, BusinessPlanningFilled, BusinessPlanningHover } from '@im/ui-lib/icons/nav/BusinessPlanning';
import { DataIngestion, DataIngestionFilled, DataIngestionHover } from '@im/ui-lib/icons/nav/DataIngestion';
import { Events, EventsFilled, EventsHover } from '@im/ui-lib/icons/nav/Events';
import { Help, HelpFilled, HelpHover } from '@im/ui-lib/icons/nav/Help';
import { MyBusiness, MyBusinessFilled, MyBusinessHover } from '@im/ui-lib/icons/nav/MyBusiness';
import { Products, ProductsFilled, ProductsHover } from '@im/ui-lib/icons/nav/Products';
import { Resources, ResourcesFilled, ResourcesHover } from '@im/ui-lib/icons/nav/Resources';
import { Services, ServicesFilled, ServicesHover } from '@im/ui-lib/icons/nav/Services';
import { Settings, SettingsFilled, SettingsHover } from '@im/ui-lib/icons/nav/Settings';
import { Solutions, SolutionsFilled, SolutionsHover } from '@im/ui-lib/icons/nav/Solutions';
import { ThumbsUp, ThumbsUpFilled, ThumbsUpHover } from '@im/ui-lib/icons/nav/ThumbsUp';
import { Vendors, VendorsFilled, VendorsHover } from '@im/ui-lib/icons/nav/Vendors';
import React from 'react';
import { Home } from '../../icons/Home';
import { HomeFilled } from '../../icons/HomeFilled';
import { jsx as _jsx } from "react/jsx-runtime";
var icons = {
  home: {
    active: HomeFilled,
    "default": Home,
    hover: HomeFilled
  },
  myBusiness: {
    active: MyBusinessFilled,
    "default": MyBusiness,
    hover: MyBusinessHover
  },
  products: {
    active: ProductsFilled,
    "default": Products,
    hover: ProductsHover
  },
  vendors: {
    active: VendorsFilled,
    "default": Vendors,
    hover: VendorsHover
  },
  help: {
    active: HelpFilled,
    "default": Help,
    hover: HelpHover
  },
  solutions: {
    active: SolutionsFilled,
    "default": Solutions,
    hover: SolutionsHover
  },
  services: {
    active: ServicesFilled,
    "default": Services,
    hover: ServicesHover
  },
  events: {
    active: EventsFilled,
    "default": Events,
    hover: EventsHover
  },
  resources: {
    active: ResourcesFilled,
    "default": Resources,
    hover: ResourcesHover
  },
  bundles: {
    active: BundlesFilled,
    "default": Bundles,
    hover: BundlesHover
  },
  business: {
    active: BusinessPlanningFilled,
    "default": BusinessPlanning,
    hover: BusinessPlanningHover
  },
  dataingestion: {
    active: DataIngestionFilled,
    "default": DataIngestion,
    hover: DataIngestionHover
  },
  settings: {
    active: SettingsFilled,
    "default": Settings,
    hover: SettingsHover
  },
  integrationshub: {
    active: AppstoreFilled,
    "default": Appstore,
    hover: AppstoreHover
  },
  feedback: {
    active: ThumbsUpFilled,
    "default": ThumbsUp,
    hover: ThumbsUpHover
  }
};
export function renderSideNavItemIcon(key, active, hover) {
  var map = icons[key];
  if (!map) {
    return null;
  }
  var Icon = map["default"];
  if (active) {
    Icon = map.active;
  } else if (hover) {
    Icon = map.hover;
  }
  return /*#__PURE__*/_jsx(Icon, {
    "data-element": "Icon",
    "data-component": "renderSideNavItemIcon",
    "data-source-file": "renderSideNavItemIcon.tsx"
  });
}